/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetIntegrationTemplatesByTypeResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetIntegrationTemplatesByTypeResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/integrations/templates/{type}
 */
export interface WithTypeItemRequestBuilder extends BaseRequestBuilder<WithTypeItemRequestBuilder> {
    /**
     * Lists the providers available for a single category — every payment gateway, say — and what each one needs before it can be created: its configuration fields, the names of the credentials it asks for, and whether it authorises through OAuth. Anonymous by design: this describes what the platform supports, holds nothing belonging to any organisation, and is what an unauthenticated setup screen renders from. Credential fields are described here, never valued — no secret is exposed by this endpoint. A type nobody has templates for returns an empty list rather than 404. Use GET /api/integration-templates for every type at once, or GET /api/integrations/available for the same catalogue annotated with an organisation's own setup status.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetIntegrationTemplatesByTypeResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetIntegrationTemplatesByTypeResponse | undefined>;
    /**
     * Lists the providers available for a single category — every payment gateway, say — and what each one needs before it can be created: its configuration fields, the names of the credentials it asks for, and whether it authorises through OAuth. Anonymous by design: this describes what the platform supports, holds nothing belonging to any organisation, and is what an unauthenticated setup screen renders from. Credential fields are described here, never valued — no secret is exposed by this endpoint. A type nobody has templates for returns an empty list rather than 404. Use GET /api/integration-templates for every type at once, or GET /api/integrations/available for the same catalogue annotated with an organisation's own setup status.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithTypeItemRequestBuilderUriTemplate = "{+baseurl}/api/integrations/templates/{type}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithTypeItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithTypeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetIntegrationTemplatesByTypeResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
